import React from 'react';
import styles from './styles.less';

import Comic from '../comics/comic';
import Promo from '../promo';

class Content extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const data = this.props.data;

        if (data.series) {
            return this.renderComic(data);
        } else if (data.promo) {
            return this.renderPromo(data);
        }
    }

    renderComic (data) {
        return (
            <Comic
                className={ styles.comic }
                data={ data }
                seriesLink
            />);
    }

    renderPromo (data) {
        return (
            <Promo
                className={ styles.comic }
                data={ data }
            />);
    }
}


export default Content;



// WEBPACK FOOTER //
// ./src/client/components/content/index.js